import { api } from "@/api"
import type { FileExportFormat } from "@/composables/options/useFileExportFormatOptions"

export const exportProducts = async (
  fileExtension?: FileExportFormat
) => {
  const response = await api.get<Blob | string>(
    "/products/export/",
    {
      query: { format: fileExtension },
    }
  )
  return downloadFileFromResponse(response)
}
